import React, { Component } from 'react';
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import { connect } from 'react-redux'; // to connect to redux store from containers redux.js or any other redux store
import Header from 'components/ProfileBanner';
import List from 'components/PackagesList';
import Session from 'components/SessionReplica';
import NavOnScroll from 'components/NavOnScroll';
import Footer from 'components/MiniFooter';
import { getSAProfile } from 'containers/Profile-view/actions';
import { selector } from 'containers/Profile-view/redux';
import { RegisterAthlete } from 'routes/routeNames';
import Loader from 'components/FullScreenLoader';// to show loder on screen whenever there is a api call or operations in component
import renderIf from 'render-if';// to use conditional rendering based on values that is provided to component
import { logPageView, initGA } from 'utils/analytics';
import { Helmet } from 'react-helmet';
import styles from './Packages.scss';// to import local scss fle

class Packages extends Component {
  static propTypes = {
    attributes: PropTypes.shape(),
    getSAProfile: PropTypes.func,
    profile: PropTypes.shape(), // eslint-disable-line
    isLoading: PropTypes.bool.isRequired,
    history: PropTypes.shape(),
  };
  static defaultProps = {
    attributes: {},
    getSAProfile: () => {},
    profile: {},
    push: PropTypes.func.isRequired,
    history: {
      push: () => {},
    },
  };
  constructor(props) {
    super(props);
    this.state = {
      showFixedNavbar: false,
    };
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    initGA();
    logPageView(this.props.match.path); // eslint-disable-line

    const paymentStatus = window.sessionStorage.getItem('kiro');
    if (this.props.attributes.size > 0 && !this.props.isLoading &&
            this.props.attributes.zoneinfo === 'STUDENT' && !this.props.attributes.get('profile') === 'PENDING'
      && paymentStatus === null) {
      const saProfile = this.props.attributes.get('profile');
      this.props.getSAProfile(saProfile);
    } else if (this.props.attributes.size > 0 &&
            this.props.attributes.get('zoneinfo') === 'STUDENT' &&
            this.props.attributes.get('profile') === 'PENDING') {
      this.props.history.push(RegisterAthlete);
    }
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillReceiveProps(nextProps) {
    const paymentStatus = window.sessionStorage.getItem('kiro');
    if (nextProps.attributes.size > 0 && !nextProps.isLoading && !nextProps.profile.size > 0
        && nextProps.attributes.get('zoneinfo') === 'STUDENT' && paymentStatus === null) {
      const saProfile = nextProps.attributes.get('profile');
      this.props.getSAProfile(saProfile);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }


  handleScroll(event) {
    const scrollTop = event.srcElement.body.scrollTop;
    if (scrollTop > 80) {
      this.setState({ showFixedNavbar: true });
    } else {
      this.setState({ showFixedNavbar: false });
    }
  }
  render() {
    const renderLoader = renderIf(this.props.attributes.get('zoneinfo') === 'STUDENT' && this.props.isLoading);
    return (
      <div className={styles.container}>
        <Helmet>
          <title>MyRecruitBoard – Get Recruited. Best Value for the Pricing</title>
          <meta name="description" content="College Football Recruiting Best Value for the Pricing!" />
          <meta name="Keywords" content="Affordable packages, Package for Senior, Package for Senior, Package for FRESHMAN, Package for SOPHOMORE, Package for Junior, Package for Middle school" />
        </Helmet>
        {renderLoader(
          <Loader />,
          )}
        {this.state.showFixedNavbar === true ? <NavOnScroll {...this.props} /> : ''}
        <Header {...this.props} usedFor="pricing" />
        <List {...this.props} />
        <Footer />
      </div>
    );
  }
}

export default connect(
    selector,
    { getSAProfile })(Session(Packages));



// WEBPACK FOOTER //
// ./src/containers/Packages/Packages.js